import { helper } from '@ember/component/helper';
import { CampaignType } from 'cio/models/campaign';

export function campaignBroadcastPath([type]: [CampaignType | 'newsletter' | 'transactional_message']) {
  if (type === 'newsletter') {
    return 'broadcasts.newsletter';
  }

  if (type === CampaignType.APITriggered) {
    return 'broadcasts.broadcast';
  }

  if (type === 'transactional_message') {
    return 'transactional.message';
  }

  return 'campaigns.campaign';
}

export default helper(campaignBroadcastPath);
